import Ajax from '../ajax';

export default {
  list: (data) => Ajax('get', 'promotion', data),
  add: (data) => Ajax('post', 'promotion', data),
  get: (pcode) => Ajax('get', `promotion/${pcode}`),
  edit: (pcode, data) => Ajax('put', `promotion/${pcode}`, data),
  delete: (pcode) => Ajax('delete', `promotion/${pcode}`),
  modifyStatus: (pcode, stat) => Ajax('put', `promotion/${pcode}/enable?enabled=${stat}`),
};
